export class Turno {
  constructor({
    id = null,
    descricao = null,
    horaInicio = null,
    horaFim = null,
  }) {
    this.id = id;
    this.descricao = descricao;
    this.horaInicio = horaInicio;
    this.horaFim = horaFim;
  }
  static Build() {
    return new Turno({
      id: null,
      descricao: null,
      horaInicio: null,
      horaFim: null,
    });
  }
  format() {
    return this;
  }
}
